import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

import { AuthProvider } from './context/AuthContext';
import { UserProvider } from "./context/UserContext";
import { NewArrivalProvider } from './context/NewArrivalContext';
import { TrendingProvider } from './context/TrendingContext';
import { CategoryProvider } from './context/CategoryContext';
import { WishlistProvider } from './context/WishlistContext';
import { ShipstyleProvider } from './context/ShipstyleContext';
import { ForgotPasswordProvider } from './context/ForgotPasswordContext';
import { ResetPasswordProvider } from "./context/ResetPasswordContext";
import { ProductProvider } from './context/ProductsContext';
import { ProfileProvider } from "./context/ProfileContext";
import { OrdersProvider } from "./context/OrdersContext";
import { CartProvider } from './context/CartContext';
import { AddressProvider } from './context/AddressContext';
import { ReviewProvider } from './context/ReviewContext';
import { PromoCodeProvider } from "./context/PromoCodeContext";
import { ColorProvider } from "./context/ColorContext";
import { FabricProvider } from "./context/FabricContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/"> {/* ✅ correct place */}
      <AuthProvider>
        <UserProvider>
          <NewArrivalProvider>
          <TrendingProvider>
           <CategoryProvider>
              <WishlistProvider>
                <ShipstyleProvider>
                  <ForgotPasswordProvider>
                    <ResetPasswordProvider>
                      <ProductProvider>
                        <ProfileProvider>
                          <OrdersProvider>
                            <CartProvider>
                              <AddressProvider>
                                <PromoCodeProvider>
                                  <ReviewProvider>
                                    <ColorProvider>
                                     <FabricProvider>
                                        <App />
                                    </FabricProvider>
                                    </ColorProvider>
                                  </ReviewProvider>
                                </PromoCodeProvider>
                              </AddressProvider>
                            </CartProvider>
                          </OrdersProvider>
                        </ProfileProvider>
                      </ProductProvider>
                    </ResetPasswordProvider>
                  </ForgotPasswordProvider>
                </ShipstyleProvider>
              </WishlistProvider>
            </CategoryProvider>
          </TrendingProvider>
          </NewArrivalProvider>
        </UserProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
